define('models/legacyContract',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.LegacyContract = T1Model.extend({
    url: "legacy_contracts/",
    fixture: "-legacy_contracts"
  });
  return T1.Models.LegacyContract;
});
